// Konfigurasi Operasi Otomatis Cakra Digital Innovation
export const OPERATIONS_CONFIG = {
  // Tanggal mulai operasi perusahaan
  companyStartDate: '2026-02-15',
  
  // Konfigurasi operasional bulanan
  monthlyOperations: {
    // Hari pemeliharaan sistem (setiap tanggal)
    maintenanceDay: 1,
    
    // Hari pembuatan laporan (setiap tanggal)
    reportingDay: 25,
    
    // Hari evaluasi layanan (setiap tanggal)
    evaluationDay: 15,
    
    // Deadline pembayaran untuk layanan subscription
    paymentDeadline: 5,
    
    // Hari pengiriman invoice (setiap tanggal)
    invoiceDay: 28
  },
  
  // Konfigurasi operasional tahunan
  yearlyOperations: {
    // Bulan evaluasi harga (inflasi tahunan)
    priceEvaluationMonth: 0, // Januari
    
    // Bulan penawaran diskon khusus
    discountMonths: {
      newYear: 0,      // Januari
      independenceDay: 7, // Agustus
      ramadan: 2,      // Maret (perkiraan)
      yearEnd: 11      // Desember
    },
    
    // Bulan maintenance sistem besar
    majorMaintenanceMonth: 11, // Desember
    
    // Bulan evaluasi layanan komprehensif
    serviceEvaluationMonth: 6 // Juli
  },
  
  // Konfigurasi layanan dengan periode otomatis
  services: {
    website: {
      supportPeriod: 'tahun',
      maintenanceFrequency: 'bulanan',
      warrantyPeriod: 365 // hari
    },
    seo: {
      reportingFrequency: 'bulanan',
      optimizationFrequency: 'mingguan',
      contractPeriod: 'bulan'
    },
    socialMedia: {
      contentFrequency: 'harian',
      reportingFrequency: 'bulanan',
      strategyReview: 'bulanan'
    },
    software: {
      supportPeriod: 'tahun',
      updateFrequency: 'bulanan',
      warrantyPeriod: 365 // hari
    }
  },
  
  // Konfigurasi pricing otomatis
  pricing: {
    baseYear: 2026,
    inflationRate: 0.05, // 5% per tahun
    discountConfig: {
      newYear: { rate: 0.10, duration: '2 minggu' },
      independenceDay: { rate: 0.17, duration: '1 minggu' },
      ramadan: { rate: 0.15, duration: '1 bulan' },
      yearEnd: { rate: 0.20, duration: '2 minggu' }
    },
    maintenancePricing: {
      basic: 200000,
      professional: 350000,
      enterprise: 500000
    }
  },
  
  // Konfigurasi operasional client
  clientOperations: {
    onboardingDuration: 7, // hari
    firstReportDay: 7, // hari setelah mulai
    reviewFrequency: 30, // hari
    supportResponseTime: {
      basic: '24-48 jam',
      professional: '2-4 jam',
      enterprise: '1-2 jam'
    }
  }
};

// Fungsi helper untuk operasi otomatis
export const getOperationDates = () => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();
  
  return {
    // Tanggal operasional bulan ini
    thisMonth: {
      maintenance: new Date(currentYear, currentMonth, OPERATIONS_CONFIG.monthlyOperations.maintenanceDay),
      reporting: new Date(currentYear, currentMonth, OPERATIONS_CONFIG.monthlyOperations.reportingDay),
      evaluation: new Date(currentYear, currentMonth, OPERATIONS_CONFIG.monthlyOperations.evaluationDay),
      paymentDeadline: new Date(currentYear, currentMonth, OPERATIONS_CONFIG.monthlyOperations.paymentDeadline),
      invoice: new Date(currentYear, currentMonth, OPERATIONS_CONFIG.monthlyOperations.invoiceDay)
    },
    
    // Tanggal operasional bulan depan
    nextMonth: {
      maintenance: new Date(currentYear, currentMonth + 1, OPERATIONS_CONFIG.monthlyOperations.maintenanceDay),
      reporting: new Date(currentYear, currentMonth + 1, OPERATIONS_CONFIG.monthlyOperations.reportingDay),
      evaluation: new Date(currentYear, currentMonth + 1, OPERATIONS_CONFIG.monthlyOperations.evaluationDay),
      paymentDeadline: new Date(currentYear, currentMonth + 1, OPERATIONS_CONFIG.monthlyOperations.paymentDeadline),
      invoice: new Date(currentYear, currentMonth + 1, OPERATIONS_CONFIG.monthlyOperations.invoiceDay)
    }
  };
};

export const isOperationDay = (operationType) => {
  const now = new Date();
  const today = now.getDate();
  
  switch (operationType) {
    case 'maintenance':
      return today === OPERATIONS_CONFIG.monthlyOperations.maintenanceDay;
    case 'reporting':
      return today === OPERATIONS_CONFIG.monthlyOperations.reportingDay;
    case 'evaluation':
      return today === OPERATIONS_CONFIG.monthlyOperations.evaluationDay;
    case 'payment':
      return today === OPERATIONS_CONFIG.monthlyOperations.paymentDeadline;
    case 'invoice':
      return today === OPERATIONS_CONFIG.monthlyOperations.invoiceDay;
    default:
      return false;
  }
};
